import { FaCheck } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import { CourseCard } from "../components/CourseCard";
import DOMPurify from "dompurify";
import { CardCourseSkeleton } from "../../cards/skeletons/CardCourseSkeleton";
import SkeletonCard from "../../skeletons/SkeletonCard";

// --- DATA YANG SUDAH DISATUKAN ---
// Sekarang kita hanya punya satu array `courses` yang berisi semua informasi, termasuk status.
const data = {
  title: "Course 1: Introduction to Cryptocurrency",
  subtitle: "Intro to Crypto & Blockchain",
  courses: [
    {
      id: 1,
      title: "1.1 What is Cryptocurrency?",
      duration: "20 Mins",
      status: "On Going", // Status sedang dikerjakan
      concepts: ["Overview of digital currencies", "Key terms and concepts"],
    },
    {
      id: 2,
      title: "1.2 Basics of Blockchain",
      duration: "20 Mins",
      status: "Finish", // Status sudah selesai
      concepts: ["Overview of digital currencies", "Key terms and concepts"],
    },
    {
      id: 3,
      title: "1.3 The Future of Digital Assets",
      duration: "15 Mins",
      status: "Not Started", // Status belum dimulai
      concepts: ["Exploring DeFi and NFTs", "Future predictions"],
    },
    {
      id: 4,
      title: "1.4 Setting Up Your Wallet",
      duration: "10 Mins",
      status: "Not Started", // Status belum dimulai
      concepts: ["Choosing a secure wallet", "First transaction guide"],
    },
    {
      id: 5,
      title: "1.5 Understanding Gas Fees",
      duration: "25 Mins",
      status: "Not Started", // Status belum dimulai
      concepts: ["How fees are calculated", "Tips for optimization"],
    },
  ],
};
// --- AKHIR DATA ---

// Komponen Utama yang sudah direfaktor
const SubCourseLearning = ({ coursesDetail, loading }) => {
  return (
    <div className="p-4 sm:p-6 md:p-8 bg-white  max-h-[85vh] overflow-y-auto no-scrollbar rounded-xl">
      <div className="mx-auto">
        <div className="mb-6">
          <h1 className="text-3xl font-bold text-gray-900 text-left !m-0">
            {loading ? (
              <SkeletonCard
                type="text"
                lines={1}
                widths={["200px"]}
                heights={["25px"]}
              />
            ) : (
              coursesDetail?.title
            )}
          </h1>
          {loading ? (
            <div className="mt-3">
              <SkeletonCard
                type="text"
                lines={1}
                widths={["100px"]}
                heights={["15px"]}
              />
            </div>
          ) : (
            <p
              className="text-md text-gray-600"
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(coursesDetail?.description),
              }}
            />
          )}
        </div>

        {/* Grid Terpadu untuk Semua Pelajaran */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-4">
          {loading
            ? [...Array(5)].map((_, idx) => <CardCourseSkeleton key={idx} />)
            : !!coursesDetail?.contents?.length
            ? coursesDetail?.contents?.map((lesson) => (
                <CourseCard key={lesson.id} lesson={lesson} />
              ))
            : null}
        </div>
      </div>
    </div>
  );
};

export default SubCourseLearning;
